

export const MIOBSPDialogActions = {

    // Demande d'affichage de la boite de dialogue
    SHOW_MIOBSPDIALOG_ACTION: {
        type: 'MIOBSPDialogActions.SHOW_MIOBSPDIALOG_ACTION', build: (backgroundClass = 'ModalOverlay') => {
            return {type: MIOBSPDialogActions.SHOW_MIOBSPDIALOG_ACTION.type, payload: {backgroundClass}}
        }
    },

    // Demande d'affichage de la boite de dialogue
    CLOSE_MIOBSPDIALOG_ACTION: {
        type: 'MIOBSPDialogActions.CLOSE_MIOBSPDIALOG_ACTION', build: () => {
            return {type: MIOBSPDialogActions.CLOSE_MIOBSPDIALOG_ACTION.type}
        }
    },
}
